import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuánto tiempo tarda en llegar el PDF?',
  a: 'Es descarga inmediata. Pagas y en segundos tienes el PDF disponible para descargar en tu celular o computadora. No hay esperas.'
}, {
  q: '¿Necesito experiencia o estudios previos?',
  a: 'No. Los 6 micro-servicios del plan fueron elegidos específicamente porque cualquier persona puede ofrecerlos hoy con solo un celular y disposición de actuar.'
}, {
  q: '¿Funciona en mi país?',
  a: 'Sí. El plan incluye métodos de cobro específicos para Colombia, México, Argentina, Venezuela, Chile, Perú, Ecuador, España y más países de LATAM.'
}, {
  q: '¿Es un curso en video o un PDF?',
  a: 'Es un ebook PDF de 20 páginas. Lo descargas, lo lees en menos de 1 hora y empiezas a aplicarlo el mismo día que lo compras.'
}, {
  q: '¿Cuánto puedo ganar realmente?',
  a: 'La meta mínima del plan es $50 USD en 48 horas. El resultado depende de cuántos mensajes envíes y qué servicio del plan elijas aplicar primero.'
}, {
  q: '¿Qué pasa si no funciona para mí?',
  a: 'Tienes 7 días de garantía total. Si aplicaste el plan y no obtuviste resultados, te devolvemos el dinero completo sin preguntas.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-24 bg-dark-card border-y border-white/5" data-id="element-52">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-53">
        <FadeIn data-id="element-54">
          <div className="text-center mb-12" data-id="element-55">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-56">
              FAQ
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-57">
              Preguntas frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-58">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-59">
              <div className="border border-white/10 rounded-2xl overflow-hidden bg-[#111111]" data-id="element-60">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-61">
                  <span className="text-lg md:text-xl font-medium text-white pr-8 font-sans" data-id="element-62">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-[#ADFF2F] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-63" />
                </button>

                <AnimatePresence data-id="element-64">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-65">
                      <div className="px-6 pb-6 pt-2 text-gray-400 text-base md:text-lg leading-relaxed font-sans" data-id="element-66">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};